import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Search } from "../../shared/Search";
import { TRequirement } from "./modal";
import { Fetch } from "../../utilities/fetch";
import { Checkbox } from "primereact/checkbox";
import { useToast } from "../../context/toastProvider";

interface Iprops {
    data?: TRequirement,
    open: boolean,
    hideDialog: () => void,
    reload: () => void,
}
type TAllocate = {
    id: number,
    name: string,
    isAllocated: boolean,
    action?: "Allocate" | "Deallocate",
}

export const Allocate = (props: Iprops) => {
    const { showToast } = useToast();
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState<Array<TAllocate>>([]);
    const [search, setSearch] = useState<string | null>(null);

    const saveToDB = async () => {
        setLoading(true);
        const data: Array<any> = [];
        tableData.forEach(e => {
            if (e.action) {
                const _obj = {
                    recruiterId: e.id,
                    remove: e.action === "Deallocate"
                }
                data.push(_obj);
            }
        });
        if (data.length > 0) {
            const response = await Fetch<{ reqId: number, hadSubmission: boolean }>(`SalesMyRequirement/${props.data?.id}/allocations`, {
                method: "POST",
                body: data,
                onError: (m) => showToast({ severity: 'error', detail: m })
            });
            if (response) {
                if (response.hadSubmission) showToast({ severity: 'warn', detail: "Updated Successfully, Can't deallocate recruiter(s) with submission." });
                else showToast({ severity: 'success', detail: 'Updated Successfully' });
                props.hideDialog();
                props.reload();
            }
        } else {
            showToast({ severity: 'error', detail: "Select Recruiter to Allocate", life: 3000 });
        }
        setLoading(false);
    }

    const loadTableData = async (reqId: number) => {
        setLoading(true);
        const data = await Fetch<{ data: Array<TAllocate>, message?: string }>(`SalesMyRequirement/${reqId}/allocations`);
        if (data) {
            if (data.message) showToast({ severity: 'info', detail: data.message, life: 3000 });
            setTableData(data.data);
        }
        setLoading(false);
    }

    useEffect(() => {
        if (props.open && props.data?.id) {
            loadTableData(props.data.id);
        }
    }, [props.open, props.data?.id]);

    const onHide = () => {
        props.hideDialog();
        setTableData([]);
    }

    const onCheckChange = (userId: number) => {
        let data = [...tableData];
        for (var i in data) {
            if (data[i].id === userId) {
                if (data[i].action) {
                    data[i].action = undefined;
                } else {
                    data[i].action = data[i].isAllocated ? "Deallocate" : "Allocate";
                }
                break;
            }
        }
        setTableData(data);
    }

    const checkBodyTemplate = (rowData: TAllocate) => {
        return (
            <Checkbox onChange={() => onCheckChange(rowData.id)} name={rowData.id?.toString()} checked={rowData.action === 'Allocate' || (rowData.isAllocated && rowData.action !== "Deallocate")} ></Checkbox>
        );
    };

    const headerTemplate = () => {
        return <div style={{ display: 'flex' }}>
            <span className="mr-3">Allocate Requirment</span>
            <span><Search setSearch={setSearch} removeIcon /></span>
        </div>
    }

    const footerTemplate = () => {
        let showFooter = tableData.some(e => e.action);
        if (!showFooter) return null;
        return <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
            <Button loading={loading} className="p-button-sm my-1" label="SUBMIT" type="button" onClick={saveToDB}></Button>
            <Button className="p-button-sm p-button-outlined my-1" label="CLOSE" type="button" onClick={onHide}></Button>
        </div>
    }


    return (
        <Dialog visible={props.open} style={{ width: '500px' }} header={headerTemplate} footer={footerTemplate} className="p-fluid" onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small" value={[props.data ?? {}]}>
                <Column field="id" header="ReqId" />
                <Column field="postedBy" header="Posted By" />
                <Column field="jobTitle" header="Job Title" />
                <Column field="duration" header="Duration" body={(r: TRequirement) => `${r.duration} month(s)`} />
                <Column field="location" header="Location" body={(r: TRequirement) => r.cityId ? `${r.cityName}, ${r.stateName}, ${r.countryName}` : '--'} />
            </DataTable>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                value={tableData.filter(e => !search || e.name.toLowerCase().includes(search.toLowerCase()))}
                emptyMessage="Not Available"
                loading={loading}>
                <Column body={checkBodyTemplate} headerStyle={{ width: '5%' }} />
                <Column field="name" header="Name" headerStyle={{ width: '15%' }} />
                <Column field="role" header="Role" headerStyle={{ width: '15%' }} body={'Recruiter'} />
            </DataTable>
        </Dialog>
    );
}
